import { useState } from "react";

const useImageUpload = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [previewImageUrl, setPreviewImageUrl] = useState(null);
  const [uploadPercentage, setUploadPercentage] = useState(0);

  const setNewImage = (imageFile) => {
    setSelectedImage(imageFile);
    setPreviewImageUrl(URL.createObjectURL(imageFile));
  };

  const handleUploadProgress = (progressEvent) => {
    const { loaded, total } = progressEvent;
    const percentCompleted = Math.floor((loaded * 100) / total);
    setUploadPercentage(percentCompleted);
  };

  const reset = () => {
    setSelectedImage(null);
    setPreviewImageUrl(null);
    setUploadPercentage(0);
  };

  return {
    selectedImage,
    previewImageUrl,
    uploadPercentage,
    handleUploadProgress,
    setNewImage,
    reset,
  };
};

export default useImageUpload;